module.exports = __webpack_public_path__ + "static/media/ApplicationConsulting.78a5be85.svg";